import AssignUserModal from "../../components/modals/account/assign.modal";
import AccountCreateModal from "../../components/modals/account/create.modal";
import PasswordResetModal from "../../components/modals/account/password-reset.modal";
import AdditionalCreateModal from "../../components/modals/additional/create.modal";
import AlertDialog from "../../components/modals/alert.modal";
import AssignZoneModal from "../../components/modals/branch/assign-zone.modal";
import AssignBranchModal from "../../components/modals/branch/assign.modal";
import BranchCreateModal from "../../components/modals/branch/create.modal";
import BranchExpirationModal from "../../components/modals/branch/expiration.modal";
import BranchSuspendModal from "../../components/modals/branch/suspend.modal";
import PrioAuthorizationModal from "../../components/modals/branch/priorAuthorization.modal";
import ConfirmDialog from "../../components/modals/confirm.modal";
import DeviceCreateModal from "../../components/modals/device/create.modal";
import DeviceColorModal from "../../components/modals/device/color.modal";
import DeviceStorageModal from "../../components/modals/device/storage.modal";
import DeviceOrderModal from "../../components/modals/device/order.modal";
import DeviceEventPeriodModal from "../../components/modals/device/event-period.modal";
import DefaultDeviceSelectModal from "../../components/modals/device/default-select.modal";
import DpDeviceSelectModal from "../../components/modals/device/dp-select.modal";
import MainDeviceSelectModal from "../../components/modals/device/main-select.modal";
import FileUploadModal from "../../components/modals/file-uplaod.modal";
import InquiryCreateModal from "../../components/modals/inquiry-create.modal";
import PartnerCreateModal from "../../components/modals/partner/create.modal";
import PaymentDetailModal from "../../components/modals/payment/detail.modal";
import PaymentHistoryListModal from "../../components/modals/payment/history-list.modal";
import PostcodeModal from "../../components/modals/postcode.modal";
import EventCreateModal from "../../components/modals/quotation/event.modal";
import NavigationConfirmModal from "../../components/modals/quotation/navi-confirm.modal";
import QuotationImportModal from "../../components/modals/quotation/import.modal";
import QuotationPasteModal from "../../components/modals/quotation/paste.modal";
import UsimTelecomSelectModal from "../../components/modals/quotation/usim-telecom-select.modal";
import SelectFieldModal from "../../components/modals/select-field.modal";
import TextFieldModal from "../../components/modals/text-field.modal";

export const MODAL_KEY = {
  Confirm: 'confirm',
  Alert: 'alert',

  AccountCreate: 'account-create',
  AdditionalCreate: 'additional-create',
  AssignBranch: 'assign-branch',
  AssignZone: 'assign-zone',
  AssignUser: 'assign-user',

  BranchCreate: 'branch-create',
  BranchExpiration: 'branch-expiration',
  BranchSuspend: 'branch-suspend',

  DeviceCreate: 'device-create',
  DeviceColor: 'device-color',
  DeviceStorage: 'device-storage',
  DeviceOrder: 'device-order',
  DeviceEventPeriod: 'device-event-period',
  DeviceMainSelect: 'device-main-select',
  DeviceDefaultSelect: 'device-default-select',
  DeviceDPSelect: 'device-dp-select',

  EventCreate: 'event-create',

  FileUpload: 'file-upload',

  InquiryCreate: 'inquiry-create',

  TextField: 'text-field',

  NaviConfirm: 'navi-confirm',

  PartnerCreate: 'partner-create',
  PasswordReset: 'password-reset',
  PaymentDetail: 'payment-detail',
  PaymentHistoryList: 'payment-history-list',
  Prior: 'prior',

  Postcode: 'postcode',

  QuotationImport: 'quotation-import',
  QuotationPaste: 'quotation-paste',

  SelectField: 'select-field',

  UsimTelecomSelect: 'usim-telecom-select',
} as const;

export type ModalKey = typeof MODAL_KEY[keyof typeof MODAL_KEY];

export const MODAL_COMPONENTS_MAP = {
  [MODAL_KEY.Confirm]: ConfirmDialog,
  [MODAL_KEY.Alert]: AlertDialog,

  // 계정 생성 모달
  [MODAL_KEY.AccountCreate]: AccountCreateModal,

  // 사전승낙서 화면 모달
  [MODAL_KEY.Prior]: PrioAuthorizationModal,

  // 지점 배정 모달
  [MODAL_KEY.AssignBranch]: AssignBranchModal,

  // 부가서비스 생성 모달
  [MODAL_KEY.AdditionalCreate]: AdditionalCreateModal,

  // 지점 사용자 배정 모달
  [MODAL_KEY.AssignUser]: AssignUserModal,

  // 인근 지역 배정 모달
  [MODAL_KEY.AssignZone]: AssignZoneModal,

  // 지점 생성 모달
  [MODAL_KEY.BranchCreate]: BranchCreateModal,
  [MODAL_KEY.BranchExpiration]: BranchExpirationModal,
  // 지점 정지 모달
  [MODAL_KEY.BranchSuspend]: BranchSuspendModal,

  // 기종 생성 모달
  [MODAL_KEY.DeviceCreate]: DeviceCreateModal,
  [MODAL_KEY.DeviceColor]: DeviceColorModal,
  [MODAL_KEY.DeviceStorage]: DeviceStorageModal,
  [MODAL_KEY.DeviceOrder]: DeviceOrderModal,
  [MODAL_KEY.DeviceEventPeriod]: DeviceEventPeriodModal,

  // 기종 선택 모달
  [MODAL_KEY.DeviceMainSelect]: MainDeviceSelectModal,
  [MODAL_KEY.DeviceDefaultSelect]: DefaultDeviceSelectModal,
  [MODAL_KEY.DeviceDPSelect]: DpDeviceSelectModal,

  [MODAL_KEY.EventCreate]: EventCreateModal,

  [MODAL_KEY.FileUpload]: FileUploadModal,

  // 문의 생성 모달
  [MODAL_KEY.InquiryCreate]: InquiryCreateModal,

  // 텍스트 필드 모달
  [MODAL_KEY.TextField]: TextFieldModal,

  [MODAL_KEY.NaviConfirm]: NavigationConfirmModal,

  // 제휴 업체 생성/수정 모달
  [MODAL_KEY.PartnerCreate]: PartnerCreateModal,

  // 비밀번호 변경 모달
  [MODAL_KEY.PasswordReset]: PasswordResetModal,

  // 결제 상세 모달
  [MODAL_KEY.PaymentDetail]: PaymentDetailModal,
  [MODAL_KEY.PaymentHistoryList]: PaymentHistoryListModal,

  // 우편번호 모달
  [MODAL_KEY.Postcode]: PostcodeModal,

  // 시세표 가져오기(다른 지점 → 현재 폼 복사) 모달
  [MODAL_KEY.QuotationImport]: QuotationImportModal,

  // 시세표 복사 모달
  [MODAL_KEY.QuotationPaste]: QuotationPasteModal,

  // 선택 필드 모달
  [MODAL_KEY.SelectField]: SelectFieldModal,

  [MODAL_KEY.UsimTelecomSelect]: UsimTelecomSelectModal,
} as const;
